import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import "../assets/Styles/ApplicationStyles.css";

export default function Loader() {
  return (
    <Box className="loader-container">
      <Box className="loader-content d-flex justify-content-center align-items-center">
        <Box
          sx={{
            display: "flex"
          }}
        >
          <CircularProgress />
        </Box>
      </Box>
    </Box>
  );
}
